<div class="toast-booking">
    <p-toast position="top-right" [key]="keyToast">
        <ng-template let-message pTemplate="message">
            <i [ngClass]="toastIconMap[message.severity]" class="!text-xl !leading-[20px]"></i>
            <div class="toast-content">{{ message.detail }}</div>
        </ng-template>
    </p-toast>
</div>
